import React from 'react';
import { motion } from 'framer-motion';
import { WhyTherapyCardFirst } from './whyTherapyCardFirst';
import { animationParams, animationVariants } from 'fragments';
import { whyTherapyCardFirstData, whyTherapyCardSecondData } from './constants';
import { WhyTherapyCardSecond } from './whyTherapyCardSecond';
import { IsImageLoaded } from 'utils';
import { landingImages } from 'assets';

export const WhyTherapy = () => {
    const beckLoaded = IsImageLoaded(landingImages.whyTherapyBeck);

    return (
        <div
            className="why-therapy-wrapper"
            style={{
                backgroundImage: `url(${beckLoaded ? landingImages.whyTherapyBeck : landingImages.whyTherapyBeckSmall})`,
            }}
        >
            <div className="why-therapy-beck-image">
                <img src={landingImages.vectorImg} alt="vector" style={{ width: '100%', height: '100%' }} />
            </div>

            <div className="why-therapy-box">
                <div className="container">
                    <div className="why-therapy-block">
                        <div style={{ overflow: 'hidden' }}>
                            <motion.h2 className="why-therapy-title" {...animationParams} variants={animationVariants.titleVariant}>
                                Why TherapyLake?
                            </motion.h2>
                        </div>

                        <div style={{ overflow: 'hidden' }}>
                            <p className="why-therapy-description">
                                We built our platform to solve the frustrations of modern ABA practices. Here's how we're different.
                            </p>
                        </div>

                        <div className="why-therapy-first-cards-block">
                            {whyTherapyCardFirstData.map((item, index) => (
                                <motion.div
                                    key={index}
                                    className="powerful-feature-cards-block"
                                    {...animationParams}
                                    variants={animationVariants.cardsVariant}
                                >
                                    <WhyTherapyCardFirst {...item} />
                                </motion.div>
                            ))}
                        </div>

                        <div className="why-therapy-old-way-wrapper">
                            <div style={{ overflow: 'hidden' }}>
                                <motion.h2
                                    className="why-therapy-old-way-title"
                                    {...animationParams}
                                    variants={animationVariants.titleVariant}
                                >
                                    The Old Way is Broken
                                </motion.h2>
                            </div>

                            <div style={{ overflow: 'hidden' }}>
                                <motion.p className="why-therapy-old-way-description">
                                    Legacy platforms create more problems than they solve. See the hidden costs and restrictions common with
                                    other systems.
                                </motion.p>
                            </div>

                            <div className="why-therapy-cards-second-block">
                                {whyTherapyCardSecondData.map((item, index) => (
                                    <motion.div
                                        key={index}
                                        className="why-therapy-cards-second-box"
                                        {...animationParams}
                                        variants={animationVariants.cardsVariant}
                                    >
                                        <WhyTherapyCardSecond {...item} key={index} />
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
